
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"37.962","height":"34","viewBox":"0 0 10.044 8.996","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"icon",attrs:{"d":"M9.86 5.822v1.993c0 .55-.483.997-1.078.997H1.245c-.595 0-1.077-.447-1.077-.997V5.822","fill":"none"}}),_c('path',{staticClass:"arrow icon",attrs:{"d":"M2.33 3.338L5.02 5.829l2.692-2.491M5.08 5.88V0","fill":"none"}})])
          )
        }
      }
    